import React, { lazy } from "react";
const LibraryPage = lazy(() => import("./pages/LibraryPage"));
export const libraryRoutes = [
  { path: "/library", element: <LibraryPage /> },
];
